<template>
  <el-menu
    :default-active="router"
    class="tg-menu"
    mode="horizontal"
    @select="handleSelect"
    background-color="#30363e"
    text-color="#BAC3CE"
    active-text-color="#0EBF9C">
    <template v-for="(menu) in navMenus">
      <el-menu-item :index="menu.modules[0].webRouterName" v-if="menu.modules.length ===1 &&menu.showNav">
        {{menu.moduleMap[menu.modules[0].uuid]}}
      </el-menu-item>
      <el-submenu :index="menu.uuid" v-else>
        <template slot="title">{{navMap[menu.uuid]}}</template>
        <el-menu-item :index="module.webRouterName" v-for="module in menu.modules"> {{menu.moduleMap[module.uuid]}}
        </el-menu-item>
      </el-submenu>
    </template>
  </el-menu>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters(['navMenus', 'navMap'])
    },
    mounted() {

    },
    watch: {
      "$route": "routerChange"
    },
    data() {
      return {
        router: '',
      };
    },
    methods: {
      handleSelect(key) {
        if (key.indexOf('-') >= 0) {
          this.$message.warning('当前功能暂未开放')
          return
        }
        if (this.$route.name != key) {
          this.$router.push({name: key})
        }
      },
      routerChange() {
        let ra = this.$route.name.split('.')
        if (ra || ra.length > 2) {
          this.router = `${ra[0]}.${ra[1]}`
        } else {
          this.router = this.$route.name
        }
      }
    }
  }
</script>

<style lang="scss">
  .tg-menu.el-menu--horizontal.el-menu {
    border-bottom: none;

    .el-menu-item {
      height: $_header_height !important;
      width: 8rem;
      text-align: center;
      line-height: $_header_height;
      padding: 0 1.25rem;
      margin: 0;
    }

    .el-submenu {
      width: 8rem;

      .el-submenu__title {
        text-align: center;
      }
    }
  }

  .el-menu--popup {
    max-width: 8rem;
    min-width: 8rem;

    .el-menu-item {
      text-align: center;
    }

    .el-menu-item:hover {
      color: $f_color !important;
    }
  }

</style>
